import React from "react";

export function PageNotFound() {
  return <h2>This page does not exist</h2>;
}
